import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { DriverLicenceService } from './../models/driverlicencedetail.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, OnDestroy, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { DriverLicenceModel } from '../models/driverlicencedetail.model';
import { IKeyValueInterface,WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';


@Component({
  selector: 'wego-backoffice',
  template: require('../views/driverlicencedetail.component.html'),
  providers: [DriverLicenceService]
})

export class DriverLicenceComponent implements OnInit, OnDestroy {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  private isLoading: boolean;
  private errorMessage: string;
  model:DriverLicenceModel;
  errorModel: IKeyValueInterface[];
  flatPickrConfigDateOfBirth: FlatPickrModel;

  constructor(private driverLicenceService: DriverLicenceService
    , private router: Router
    , private authService: AuthService) {

  }

  ngOnInit() {
    this.isLoading = true;
    this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
     this.model = new DriverLicenceModel();
     this.isLoading=false;
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = false;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.maxDate = new Date(new Date());
    return flatPickrConfig;
  }
  public DriverLicenceDetail()
  {
    this.isLoading=true;
     this.driverLicenceService.AddDriverLicenceDetail(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.isLoading=false;
          localStorage.setItem('current_role', 'DRIVER');
          this.router.navigate(['/driver']);
        }
        else {
          this.errorModel = res.error;
          this.isLoading=false;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading=false;
      }
      );
  }
  public Login()
  {
    this.authService.Logout();
    this.router.navigate(['/']);

  }
  ngOnDestroy() { console.log('ngOnDestroy'); }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/validatedriverlicence/components/driverlicencedetail.component.ts